// @flow

import * as React from 'react';
import Emojify from 'app/components/shared/Emojify';

export type TriggerStepType = {
  type: 'trigger',
  id: string,
  name?: string,
  state: string,
  tooltip?: string,
  step?: {
    label: ?string
  },
  triggerProjectSlug?: ?string,
  triggerProject?: {
    name: string
  }
};

type Props = {
  build: {
    path: string
  },
  job: TriggerStepType,
  stepClassName: string
};

/* eslint-disable react/require-optimization */
// TODO: Double check these can be optimised

export default class TriggerStep extends React.Component<Props> {
  render() {
    if (this.props.job.state === "broken") {
      return (
        <div
          key={this.props.job.id}
          data-tooltip-length="medium"
          aria-label={this.props.job.tooltip}
          className={this.props.stepClassName}
        >
          {this.renderJobName()}
        </div>
      );
    }

    return (
      <a
        key={this.props.job.id}
        href={`${this.props.build.path}#job-${this.props.job.id}`}
        className={this.props.stepClassName}
      >
        {this.renderJobName()}
      </a>
    );
  }

  renderJobName() {
    if (this.props.job.name) {
      return <Emojify text={this.props.job.name} />;
    }

    let nameNode;
    if (this.props.job.triggerProject) {
      nameNode = <Emojify text={this.props.job.triggerProject.name} />;
    } else if (this.props.job.triggerProjectSlug) {
      nameNode = <code className="monospace">{this.props.job.triggerProjectSlug}</code>;
    } else {
      nameNode = "unknown pipeline";
    }

    return <span>Trigger Build on {nameNode}</span>;
  }
}
